'use client';

import clsx from 'clsx';
import Image from 'next/image';

import './OnboardingHeader.scss';

interface OnboardingHeaderProps extends React.HTMLAttributes<HTMLElement> {
  className?: string;
}

const OnboardingHeader = ({ className, ...rest }: OnboardingHeaderProps) => {
  return (
    <header className={clsx('onboarding-header', className)} {...rest}>
      <Image
        alt='logo'
        className='bs-7 is-auto'
        src='/images/logo-play.png'
        width={188}
        height={28}
        priority={true}
      />
    </header>
  );
};

export default OnboardingHeader;
